<template>
  <div v-if="data.showModal" class="modal-container">
    <div class="dimmed">
      <div class="modal">
        <div class="title">{{ title }}</div>
        <slot></slot>
        <div class="button-wrap">
          <button @click="data.showModal = false" class="button pre">
            {{ data.cancel }}
          </button>
          <button @click="confirm" class="button next">
            {{ data.confirm }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    data: {
      showModal: Boolean,
      cancel: String,
      confirm: String,
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../styles/color_palette.scss";

.modal-container {
  .dimmed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 10;
    .modal {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80%;
      max-width: 340px;
      border-radius: 16px;
      background-color: $BlueGray100;
      .title {
        padding: 20px 0;
        text-align: center;
        color: $BlueGray100;
        font-size: 14px;
        border-radius: 16px 16px 0 0;
        background-color: $Red500;
      }
      .button-wrap {
        padding: 0 16px;
        .item {
          border-bottom: 1px solid $BlueGray600;
          width: 100%;
          padding: 20px 0;
          text-align: center;
          font-size: 14px;
        }
        &:last-of-type {
          .item {
            border-bottom: none;
          }
        }
      }
      .button-wrap {
        display: flex;
        flex-direction: row;
        justify-content: stretch;
        width: 100%;
        text-align: center;
        border-top: 1px solid $BlueGray600;
        button.button {
          flex: 1;
          min-height: auto;
          padding: 20px 0;
          font-size: 14px;
          &.next {
            border-left: 1px solid $BlueGray600;
          }
        }
      }
    }
  }
}
</style>
